import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../service/auth/auth.service';
import {TokenStorageService} from '../service/auth/token-storage.service';
import {MatDialog} from '@angular/material';
import {AcceptDeclineDialogComponent} from '../dialog/accept-decline-dialog/accept-decline-dialog.component';

interface Stage {
  id: number;
  stage: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  // roles: string[] = [];

  constructor(private _router: Router,
              private authService: AuthService,
              private tokenStorage: TokenStorageService) { }

  ngOnInit(): void {
    // if (this.tokenStorage.getToken() != undefined) {
    //   this.isLoggedIn = true;
    //   // this.roles = this.tokenStorage.getUser().roles;
    // } else {
    //   this.isLoggedIn = false;
    // }

    console.log(this.tokenStorage.getToken())
  }

  onSubmit(): void {
    const { username, password } = this.form;

    this.authService.login(username, password).subscribe(
      data => {
        console.log(data)
        this.tokenStorage.saveToken(data.token);
        this.tokenStorage.saveUser(data);
        console.log(this.tokenStorage.getToken())
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this._router.navigate(['/upload/drivers-manual']);
      },
      err => {
        this.errorMessage = err.error.message;
        this.isLoginFailed = true;
      }
    );
  }

  reloadPage(): void {
    window.location.reload();
  }

}
